import { VerificationRouteKey } from 'types/verification'

export const VerificationStepTrackingLabels: Record<VerificationRouteKey, string> = {
  getStarted: 'Get started',
  businessDetails: 'Business details',
  sourceOfFunds: 'Source of funds',
  businessActivity: 'Business activity',
  businessAddress: 'Business address',
  accountRepresentative: 'Account representative',
  businessOwners: 'Business owners',
  businessDirectors: 'Business directors',
  businessCompliance: 'Business compliance',
  businessDocuments: 'Upload document',
  businessAgreements: 'Review and finish',
}
